import { Injectable, Injector } from '@angular/core';
import { WkNodeActionsService } from './wk-node-actions.service';
import { WkNodePermissionService } from './wk-node-permission.service';
import { WkNodesApiService } from './wk-nodes-api.service';

@Injectable({
  providedIn: 'root',
})
export class CoreNodeService {
  get nodesApiInstance() {
    return this.wkNodesApiService;
  }

  get nodePermissionInstance() {
    return this.wkNodePermissionService;
  }

  get nodeActionsInstance() {
    return this.wkNodeActionsService;
  }

  private readonly wkNodesApiService: WkNodesApiService;
  private readonly wkNodePermissionService: WkNodePermissionService;
  private readonly wkNodeActionsService: WkNodeActionsService;

  constructor(injector: Injector) {
    this.wkNodesApiService = injector.get<WkNodesApiService>(WkNodesApiService);
    this.wkNodePermissionService = injector.get<WkNodePermissionService>(
      WkNodePermissionService
    );
    this.wkNodeActionsService =
      injector.get<WkNodeActionsService>(WkNodeActionsService);
  }
}
